import { FontIcon } from 'office-ui-fabric-react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import * as React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { IModalDialog } from '../../../models/IModalDialog';
import { IChangePasswordProps } from './IChangePasswordProps';
import { IChangePasswordState } from './IChangePasswordState';
initializeIcons();

const getStyles = () => {
    return {
        root: {
            maxWidth: '300px',
            responsiveMode: true,
            color: '#005269'
        }
    }
};
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%", fontSize: "12px", color: '#005269'
});
const topMsgPanel = mergeStyles({
    textAlign: "center", backgroundColor: "#006d79", color: "#FFFFFF", width: "100%", padding: "5px"
});
const successMsgPanel = mergeStyles({
    color: 'green', fontSize: "14px", textAlign: "center"
});
const errorMsgPanel = mergeStyles({
    color: '#E9512D', fontSize: "14px", textAlign: "center"
});
const iconPanel = mergeStyles({
    paddingRight: "3px"
});
const topPanel = mergeStyles({
    justifyContent: "center", width: "100%", display: "flex", padding: "10px"
});;
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
export default class ChangePassword extends React.Component<IChangePasswordProps, IChangePasswordState>
{
    private dialog: IModalDialog;
    private password: string;
    private confirmPassword: string;
    private changePasswordCode: string | undefined;

    constructor(props: IChangePasswordProps, state: IChangePasswordState) {
        super(props);
        this.password = '';
        this.confirmPassword = '';

        this.state = {
            passwordError: '',
            confirmPasswordError: '',
            inputError: 'This field is Required',
            showError: false,
            isValidData: false,
            EmailId: '',
            ResendLink: false
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }

    public async componentDidMount() {
        this.changePasswordCode = this.props.connectionContext.getQueryStringByParameter('code');
        if (this.changePasswordCode !== undefined && this.changePasswordCode !== null) {
            this.checkForValidChangePasswordCode();
        }

    }

    public render(): React.ReactElement<IChangePasswordProps> {
        return (
            <div className={panel}>
                <div className={topMsgPanel}>
                    <h4>Create a new password</h4>
                </div>
                {
                    (this.state.isValidData && !this.state.ResendLink && !this.state.showError && this.state.inputError === '') && (
                        <div className={topPanel}>
                            <div>
                                <div>
                                    <p className={successMsgPanel}><FontIcon iconName="Completed" className={iconPanel} />Your account has been verified successfully. <br /> Please type and confirm a secure new password for your account. </p>
                                </div>
                                <div>
                                    <TextField label="New Password" required placeholder="New Password" styles={getStyles} maxLength={24} type="password"
                                        onChange={this.onChangePassword} errorMessage={this.state.passwordError} iconProps={{ iconName: 'Lock' }} />
                                </div>
                                <div>
                                    <TextField label="Confirm Password" required placeholder="Confirm Password" styles={getStyles} maxLength={24} type="password"
                                        onChange={this.onChangeConfirmPassword} errorMessage={this.state.confirmPasswordError} iconProps={{ iconName: 'Lock' }} />
                                </div>
                                <div>
                                    <br />
                                    <p>  <PrimaryButton text="Submit" onClick={this.submitForm} className={submitButton} iconProps={{ iconName: 'SaveAndClose' }} />
                                    </p>
                                </div>
                            </div>
                        </div>)
                }
                {
                    (!this.state.isValidData && !this.state.ResendLink && !this.state.showError && this.state.inputError === '') && (
                        <div>
                            <div>
                                <p className={errorMsgPanel}><FontIcon iconName="Error" className={iconPanel} />Invalid link or your activation link has expired. <RouterLink to='/User/ResetPassword/ResetPassword'>Click here</RouterLink> to resend activation link to your Registered email address.</p>
                            </div>
                        </div>)
                }
                {
                    (this.state.isValidData && this.state.ResendLink && !this.state.showError && this.state.inputError === '') && (
                        <div>
                            <div>
                                <p className={successMsgPanel}> <FontIcon iconName="Completed" className={iconPanel} />We have sent a verification link to your registered email address : {this.state.EmailId}. Please click on the link to complete the registration process.</p>
                            </div>
                        </div>)
                }
                {
                    (this.state.isValidData && !this.state.ResendLink && !this.state.showError && this.state.inputError === 'saved') && (
                        <div>
                            <div>
                                <p className={successMsgPanel}><FontIcon iconName="Completed" className={iconPanel} />Your have successfully reset the password for your account. <Link href="../User/Login/Login">Click here</Link> to login with your new credentials.</p>
                            </div>
                        </div>)
                }
                {
                    (this.state.isValidData && !this.state.ResendLink && this.state.showError && this.state.inputError === 'error') && (
                        <div>
                            <div>
                                <p className={errorMsgPanel}><FontIcon iconName="Error" className={iconPanel} />Please try again. If error persists contact admin (agent.network@zacco.com).</p>
                            </div>
                        </div>)
                }
            </div>
        );
    }

    private submitForm = async (): Promise<void> => {
        if (this.checkMandatoryFields() && this.changePasswordCode !== undefined && this.changePasswordCode !== null) {
            try {
                let resetPassword = {
                    code: this.changePasswordCode,
                    password: this.password
                };

                await this.props.connectionContext.put(`PasswordReset/${this.changePasswordCode}/reset`, resetPassword);
                this.setState({ isValidData: true, ResendLink: false, showError: false, inputError: 'saved' });
            } catch (error) {
                this.setState({ isValidData: false, ResendLink: false, showError: true, inputError: 'error' });
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
            }
        }
    }

    private checkForValidChangePasswordCode = async (): Promise<void> => {
        try {
            if (this.changePasswordCode !== undefined && this.changePasswordCode !== null) {
                let exists: string | null = await this.props.connectionContext.get(`PasswordReset/${this.changePasswordCode}/check`);
                if (exists != null) {
                    this.setState({ isValidData: true, ResendLink: false, showError: false, inputError: '' });
                } else {
                    this.setState({ isValidData: false, ResendLink: false, showError: false, inputError: '' });
                }
            } else {
                this.setState({ isValidData: false, ResendLink: false, showError: false, inputError: '' });
            }
        } catch (error) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }

    private checkMandatoryFields(): boolean {

        let validState: boolean = true;
        let validPassword: boolean = this.password.trim().length > 0;
        let validConfirmedPassword: boolean = this.confirmPassword.trim().length > 0;
        let passwordsMatches: boolean = this.password === this.confirmPassword;

        if (!validPassword) {
            this.setState({ passwordError: 'Password is Required' });
            validState = false;
        }
        if (!validConfirmedPassword) {
            this.setState({ confirmPasswordError: 'Confirm password is Required' });
            validState = false;
        }
        if (!passwordsMatches) {
            this.setState({ confirmPasswordError: 'Confirm password should match with Password' });
            validState = false;
        }

        this.setState((prevState: IChangePasswordState): IChangePasswordState => {
            prevState.isValidData = validState;
            return prevState;
        });
        return validState;
    }

    private onChangePassword = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IChangePasswordState): IChangePasswordState => {
            let newValue = value || '';
            const re = /^[a-zA-Z0-9~!@#$%^&*()\b]+$/;
            if (newValue.length < 1) {
                prevState.passwordError = 'Password is Required.';
                this.password = '';
            }
            else if (newValue.length > 1 && newValue.length < 8) {
                prevState.passwordError = 'Password is too short.';
                this.password = newValue;
            }
            else if (!re.test(newValue)) {
                prevState.passwordError = 'Allowed characters: [a-z],[A-Z],[0-9] and [~!@#$%^&*()]';
            }
            else {
                prevState.passwordError = '';
                this.password = newValue;
            }
            return prevState;
        });
    }

    private onChangeConfirmPassword = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IChangePasswordState): IChangePasswordState => {
            let newValue = value || '';
            const re = /^[a-zA-Z0-9~!@#$%^&*()\b]+$/;
            if (newValue.length < 1) {
                prevState.confirmPasswordError = 'Confirm Password is Required.';
                this.confirmPassword = '';
            }
            else if (newValue.length < 8) {
                prevState.confirmPasswordError = 'Confirm Password is too short.';
                this.confirmPassword = newValue;
            }
            else if (!re.test(newValue)) {
                prevState.confirmPasswordError = 'Allowed characters: [a-z],[A-Z],[0-9] and [~!@#$%^&*()]';
            }
            else if (this.password !== newValue) {
                prevState.confirmPasswordError = 'Confirm password should match with Password';
                this.confirmPassword = newValue;
            }
            else {
                prevState.confirmPasswordError = '';
                this.confirmPassword = newValue;
            }
            return prevState;
        });
    }

    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IChangePasswordState, props: IChangePasswordProps): IChangePasswordState => {
            previousState.isValidData = false;
            return previousState;
        });
    }
}